import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "bi-tmpl-detail__right__cmpt",
  style: {"margin-top":"-30px"}
}
const _hoisted_2 = {
  key: 0,
  class: "bi-tmpl-detail__right__cmpt__tips"
}
const _hoisted_3 = { style: {"width":"1200px","transform":"scale(0.32)","transform-origin":"center 0","white-space":"wrap"} }
const _hoisted_4 = { style: {"padding":"10px 24px","font-size":"14px","border":"1px solid #dbdbdb","margin-top":"16px"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%","text-align":"center","margin":"5px 0"} }, "分析结论", -1)
const _hoisted_6 = ["innerHTML"]

import PcModuleChiSquareAnalysis from '@V/bi-tmpl/src/components/bi-pc-module/pc-module-chi-square-analysis';

import { BaseRadio } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import { BaseCard } from 'xrk-components';
import { analysis } from '../../../../mock/_analysis';

const CHILD_KEY = '6_3';


export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-6-3',
  setup(__props) {

const TYPE_MAPPING = {
  1: {
    value: 'pc-module-chi-square-analysis-1',
    moduleType: 'pc-module-chi-square-analysis-1'
  },
  2: {
    value: 'pc-module-chi-square-analysis-2',
    moduleType: 'pc-module-chi-square-analysis-2'
  },
  3: {
    value: 'pc-module-chi-square-analysis-3',
    moduleType: 'pc-module-chi-square-analysis-3'
  },
  4: {
    value: 'pc-module-chi-square-analysis-4',
    moduleType: 'pc-module-chi-square-analysis-4'
  },
  5: {
    value: 'pc-module-chi-square-analysis-5',
    moduleType: 'pc-module-chi-square-analysis-5'
  },
  6: {
    value: 'pc-module-chi-square-analysis-6',
    moduleType: 'pc-module-chi-square-analysis-6'
  }
};

const { curItem, onChange } = useDetailCmpt({ childKey: CHILD_KEY });
const cmpName = name => {
  return PcModuleChiSquareAnalysis.filter(comp => comp.__name === name)[0];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_unref(curItem).tips)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(curItem).tips), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Carousel), {
      ref: "carouselRef",
      itemHeight: 190,
      itemWidth: 420 + 56
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(TYPE_MAPPING, (item, index) => {
          return _createElementVNode("div", {
            style: {"text-align":"center"},
            key: index
          }, [
            _createVNode(_unref(BaseCard), { style: {"width":"420px"} }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseRadio), {
                  class: "bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w",
                  value: item.value,
                  "model-value": _unref(curItem).value,
                  onClick: ($event: any) => (_unref(onChange)(item.value)),
                  style: {"height":"130px !important"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(cmpName(item.value)), _mergeProps({ ref_for: true }, {
                  tableHeaderList: [
                    {
                      prop: 'header',
                      label: [`卡方分析结果`],
                      subHeaderList: [
                        {
                          ..._unref(analysis)[0].chiSquareTable.header[0],
                          group: true
                        },
                        _unref(analysis)[0].chiSquareTable.header[1],
                        {
                          prop: '_title',
                          label: [_unref(analysis)[0].chiSquareTable.title],
                          subHeaderList:
                            _unref(analysis)[0].chiSquareTable.header.slice(
                              2,
                              _unref(analysis)[0].chiSquareTable.header.length - 3
                            )
                        },
                        _unref(analysis)[0].chiSquareTable.header.slice(-3, -2)[0],
                        {
                          ..._unref(analysis)[0].chiSquareTable.header.slice(-2, -1)[0],
                          group: true
                        },
                        {
                          ..._unref(analysis)[0].chiSquareTable.header.slice(-1)[0],
                          group: true
                        }
                      ]
                    }
                  ],
                  tableDataList: _unref(analysis)[0].chiSquareTable.value.map(
                    (item, index, arr) =>
                      arr.length - 1 == index
                        ? item
                        : {
                            ...item,
                            headerTit: [
                              ..._unref(analysis)[0].chiSquareTable.value[0].headerTit
                            ],
                            headerX2: [
                              ..._unref(analysis)[0].chiSquareTable.value.slice(
                                -2,
                                -1
                              )[0].headerX2
                            ],
                            headerP: [
                              ..._unref(analysis)[0].chiSquareTable.value.slice(
                                -2,
                                -1
                              )[0].headerP
                            ]
                          }
                  )
                }), null, 16))
                    ])
                  ]),
                  _: 2
                }, 1032, ["value", "model-value", "onClick"])
              ]),
              _: 2
            }, 1024)
          ])
        }), 64))
      ]),
      _: 1
    }, 512),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", {
        innerHTML: _unref(analysis)[0].resultSystem
      }, null, 8, _hoisted_6)
    ])
  ]))
}
}

})